import { render, staticRenderFns } from "./single-message-display.vue?vue&type=template&id=420ba0bc"
import script from "./single-message-display.vue?vue&type=script&lang=js"
export * from "./single-message-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports